import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import TitledHeadingText from "@coworker/apprestructured/src/task-management/components/TitledHeadingText/TitledHeadingText";
import TopFragmentWrapper from "@coworker/apprestructured/src/task-management/components/SheetTop/TopFragmentWrapper/TopFragmentWrapper";
import ViewerTop from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/ViewerTop/ViewerTop";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import {
  FixaOption,
  FixaSelect,
} from "@coworker/apprestructured/src/shared/wrappers/FixaSelect/FixaSelect";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";

function TitledHeadingTextViewerTopFragmentDemo() {
  const [label, setLabel] = useState("Question");
  const [text, setText] = useState("Where is KALLAX?");
  const [headingSize, setHeadingSize] = useState<"h1" | "h2" | "h3" | "h4">(
    "h2"
  );

  return (
    <Demo>
      <Name>TitledHeadingTextViewerTopFragment</Name>
      <Highlight>
        <ViewerTop state="pending">
          <div style={{ padding: "16px 24px" }} />
        </ViewerTop>
        <TopFragmentWrapper state="pending">
          <div
            style={{
              padding: "16px",
              background: "var(--white)",
              borderRadius: "8px",
              width: "100%",
              margin: "0 24px",
            }}
          >
            <TitledHeadingText
              label={label}
              text={text}
              headingSize={headingSize}
            />
          </div>
        </TopFragmentWrapper>
      </Highlight>
      <Actions>
        <FixaInputField
          label="label"
          type="text"
          id="titledheadingtextviewertopfragmentdemo-label"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
        />
        <FixaInputField
          label="text"
          type="text"
          id="titledheadingtextviewertopfragmentdemo-text"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <FixaSelect
          id="titledheadingtextviewertopfragmentdemo-headingsize"
          label="headingSize"
          value={headingSize}
          onChange={(e) =>
            setHeadingSize(e.target.value as "h1" | "h2" | "h3" | "h4")
          }
        >
          {(["h1", "h2", "h3", "h4"] as const).map((size) => (
            <FixaOption key={size} name={size} value={size} />
          ))}
        </FixaSelect>
      </Actions>
    </Demo>
  );
}

export default memo(TitledHeadingTextViewerTopFragmentDemo);
